module.exports = __webpack_public_path__ + "img/tk.f18a4294.svg";